import React, { useMemo, useRef } from "react";
import Image from "../../../../components/image/Image";
import Iconify from "../../../../layouts/components/iconify/iconify";
import CenterModel from "../../../../components/ui/centerModel/CenterModel";
import FormCreator from "../../../../components/finalForms/FormCreator";
import Buttons from "../../../../components/ui/button/Buttons";
import { AppIcons } from "../../../../data/appIcons";
import { getQuoteOfTheDay } from "../quoteOfTheDay/quotes";
import KpiCards from "../kpiCards/KpiCards";

const getGreetingPrefix = (date = new Date()) => {
  const hour = date.getHours();
  if (hour < 12) return "Good Morning";
  if (hour < 17) return "Good Afternoon";
  return "Good Evening";
};

const DashboardHeader = ({
  firstName,
  userId,
  user,
  profile,
  counts,
  showPopup,
  formData,
  isUpdateUserLoading,
  onEdit,
  onClose,
  onSubmit,
}) => {
  const profileSettingsRef = useRef();

  const greeting = useMemo(() => {
    const name = firstName || "there";
    return `${getGreetingPrefix()}, ${name}!`;
  }, [firstName]);

  const quote = useMemo(() => getQuoteOfTheDay(userId), [userId]);

  const email = profile?.emailAddress || user?.emailAddress || "—";
  const roleName = profile?.roleName || "—";
  const managerName = profile?.reportingManagerName || "—";

  const handleSave = () => {
    const userDetailData = profileSettingsRef.current?.getFormData();
    if (userDetailData && typeof onSubmit === "function") {
      onSubmit(userDetailData);
    }
  };

  return (
    <div className="dashboard-card dashboard-header">
      <div className="dashboard-header__top">
        <div className="dashboard-header__main">
          <div className="dashboard-header__avatar" aria-hidden="true">
            <Image
              imagePath={user?.gender === "Male" ? AppIcons.Boy : AppIcons.Girl}
              altText="avatar"
            />
          </div>

          <div className="dashboard-header__greeting">
            <div className="dashboard-header__title-row">
              <h1>{greeting}</h1>
              <button
                type="button"
                className="dashboard-header__edit"
                onClick={onEdit}
                aria-label="Edit profile"
                title="Edit profile"
              >
                <Iconify icon="mdi:pencil-outline" width={16} />
              </button>
            </div>

            <div className="dashboard-header__meta">
              <span className="dashboard-header__meta-item" title={email}>
                <Iconify icon="iconoir:mail" width={14} />
                <em>{email}</em>
              </span>
              <span className="dashboard-header__meta-item" title={roleName}>
                <Iconify icon="fluent:people-20-regular" width={14} />
                <em>{roleName}</em>
              </span>
              <span className="dashboard-header__meta-item" title={`Reporting to ${managerName}`}>
                <Iconify icon="oui:app-reporting" width={14} />
                <em>Reporting to {managerName}</em>
              </span>
            </div>
          </div>
        </div>

        <aside className="dashboard-header__quote-wrap" aria-label="Quote of the day">
          <p className="dashboard-header__quote" title={`“${quote.text}” — ${quote.author}`}>
            <span className="dashboard-header__quote-body">
              <span className="dashboard-header__quote-mark dashboard-header__quote-mark--open" aria-hidden="true">
                “
              </span>
              <span className="dashboard-header__quote-text">{quote.text}</span>
              <span className="dashboard-header__quote-mark dashboard-header__quote-mark--close" aria-hidden="true">
                ”
              </span>
            </span>
            {/* <span className="dashboard-header__quote-author">— {quote.author}</span> */}
          </p>
        </aside>
      </div>

      <div className="dashboard-header__kpis">
        <KpiCards counts={counts} />
      </div>

      {showPopup && (
        <CenterModel
          showModal={showPopup}
          className="header-task-center-model"
          handleToggleModal={onClose}
          modalTitle="Edit Personal Information"
          modelSizeClass="w-55"
        >
          <div className="cards">
            <div className="card-bodys">
              <div className="row">
                <FormCreator ref={profileSettingsRef} config={formData} />
                <div className="d-flex justify-content-end mt-3">
                  <Buttons
                    buttonTypeClassName="dark-btn"
                    buttonText="Cancel"
                    onClick={onClose}
                  />
                  <Buttons
                    buttonTypeClassName="theme-btn ml-4"
                    buttonText="Save"
                    onClick={handleSave}
                    isLoading={isUpdateUserLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        </CenterModel>
      )}
    </div>
  );
};

export default DashboardHeader;
